/* =============================================================
   HOME — Cadeira Bossa Nova
   assets/home_bossa.js
   ============================================================= */

(function () {
  'use strict';

  function cbnToggleVideo(wrapper) {
    var video = wrapper.querySelector('video');
    var play  = wrapper.querySelector('.cbn-play');
    if (!video) return;

    if (video.paused) {
      video.play();
      if (play) play.style.opacity = '0';
    } else {
      video.pause();
      if (play) play.style.opacity = '1';
    }
  }

  // Restaura ícone quando vídeo termina
  document.addEventListener('DOMContentLoaded', function () {
    var video = document.getElementById('video-a-player');
    if (!video) return;
    video.addEventListener('ended', function () {
      var play = document.getElementById('video-a-play');
      if (play) play.style.opacity = '1';
    });
  });

  window.cbnToggleVideo = cbnToggleVideo;

})();
